import React from "react";
import { ItemListProduct } from "../../types/post.type";
import MovieCard from "./MovieCard";

interface MovieGridProps {
  movies: ItemListProduct[];
  size?: "large" | "small"; // Prop to determine card size
  loadMore?: () => void; // Function to load more movies
  isLoading?: boolean; // Indicates if movies are being loaded
  isSelectMode?: boolean; // New: enable select mode
  selectedIds?: string[]; // New: list of selected movie ids
  onSelectMovie?: (id: string) => void; // New: callback when select
}

const MovieGrid: React.FC<MovieGridProps> = ({ movies, size = "large", loadMore, isLoading = false, isSelectMode = false, selectedIds = [], onSelectMovie,  }) => {
  // Avoid duplicate cards by ensuring each movie has a unique key
  const uniqueMovies = movies.filter((movie, index, self) => 
    index === self.findIndex((m) => m.id === movie.id)
  );
  
  return (
    <div className="min-h-[50vh] pb-10">
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-8 gap-4 px-4">
        {uniqueMovies.map((movie) => (
          <MovieCard
            key={`${movie.id}-${size}`}
            movie={movie}
            size={size}
            isSelectMode={isSelectMode}
            checked={selectedIds.includes(String(movie.id))}
            onSelectMovie={onSelectMovie}
          />
        ))}
      </div>
      
      {/* Loading indicator at the bottom when loading more */}
      {isLoading && movies.length > 0 && (
        <div className="flex justify-center py-4">
          <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      
      {/* Manual Load More button */}
      {loadMore && movies.length > 0 && !isLoading && (
        <div className="flex justify-center mt-8 mb-4">
          <button
            onClick={(e) => {
              e.preventDefault();
              loadMore();
            }}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
            disabled={isLoading}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default MovieGrid;
